import React, { useState, useEffect, useMemo, useContext } from 'react'
import { toast } from "react-toastify";
import { Button, Form, Input, Modal, Table } from 'antd';
import StudentContext from '../../../Helper/Students';
import courseContext from '../../../Helper/Courses';
import { searchInArray } from '../../../utils/search'
import { deleteSingleDoc, getAttendance, setAttendanceRecord, updateAttendanceRecord } from '../../../firebase/utils';
import { isDateOverForSecondModule } from '../../../utils';
import AttendanceHeader from './AttendanceHeader';
import { getAttColumn } from '../../../utils/attendanceColumn';
import useFetchUserRoles from '../../../hook';
import { isWriteAccess } from '../../../utils/adminRoles';
import AdminContext from '../../../Helper/admin';
import { AlertCircle } from 'react-feather';
import CalenderModal from '../../CalenderModal';
import AttendanceSheet from './AttendanceSheet';

const AttendanceTable = () => {
  const { students, loading, setLoading, setStudents, fetchStudents } = useContext(StudentContext)
  const { activeCourse } = useContext(courseContext)
  const [courseStudents, setCourseStudents] = useState([])
  const [createAttendance, setCreateAttendance] = useState(false);
  const [attendanceSheet, setAttendanceSheet] = useState(false);
  const [attendanceSearch, setAttendanceSearch] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [banned, setBanned] = useState(0);
  const [filterBy, setFilterBy] = useState("Filter Attendance Sheet");
  const [attendanceStatus, setAttendanceStatus] = useState({});
  const [search, setSearch] = useState("")
  const [module, setModule] = useState(0)
  const [attendanceLoading, setAttendanceLoading] = useState({
    loading: false,
    email: ""
  })
  const [randomState, setRandomState] = useState(false)
  const hasWriteAccess = useFetchUserRoles('attendence', isWriteAccess)
  const [attendanceIndexState, setAttendanceIndexState] = useState(null)
  const [courseStudentState, setCourseStudentState] = useState(null);
  const [showCalenderModal, setShowCalenderModal] = useState(null);
  const [isReason, setisReason] = useState({
    show: false,
    status: ''
  })
  const [reason, setReason] = useState('')
  const { user } = useContext(AdminContext);
  const errorSound = new Audio('../../../assets/audio/beep-warning.mp3');

  const filteredStudent = useMemo(() => {
    const keys = ['studentId', 'email', 'fullName']
    const studentFilteredData = searchInArray(courseStudents, keys, search)
    return studentFilteredData
  }, [search, courseStudents])

  const setTotal = () => {
    const attendanceStatusTemp = {
      present: 0,
      absent: 0,
      leave: 0,
      no_Attendance: 0,
      dropped: banned,
      total: 0,
    };
    attendanceStatusTemp.total = courseStudents.length;
    courseStudents.map((student) => {
      const course = student.courses.length > 0;
      if (!course) return;
      const attd = student.attendance;
      if (!attd) return attendanceStatusTemp.no_Attendance++;

      switch (attd.status) {
        case "absent": {
          attendanceStatusTemp.absent++;
          break;
        }
        case "present": {
          attendanceStatusTemp.present++;
          break;
        }
        case "leave": {
          attendanceStatusTemp.leave++;
          break;
        }
      }
    });

    setAttendanceStatus(attendanceStatusTemp);
  };

  const editReason = (reason, status) => {
    if (!reason) return
    setisReason({
      show: true,
      status
    })
  }

  const showUpdateReasonModal = (courseStudent) => {
    const { attendance, email } = courseStudent;
    setisReason({
      show: true,
      status: attendance?.status,
    })
    setReason(attendance?.reason)
    const attendanceIndex = courseStudents.findIndex(
      (att) => att.email === email
    );
    setAttendanceIndexState(attendanceIndex);
    setCourseStudentState(courseStudent);
  }

  const showReasonNotation = (status, courseStudent) => {
    const attendanceIndex = courseStudents.findIndex(
      (att) => att.email === courseStudent.email
    );
    const attendance = courseStudents[attendanceIndex].attendance
    return attendance?.status === status && attendance.reason && <AlertCircle className="alert-circle-icon" />
  }

  const updateAttendanceReason = () => {
    const attendanceRecord = {
      reason: reason.trim()
    }
    // const attendanceIndex = courseStudents.findIndex(
    //   (att) => att.email === courseStudent.email
    // );
    if (courseStudents[attendanceIndexState].attendance.reason === reason.trim()) {
      closeEditReason()
      return
    }
    courseStudents[attendanceIndexState].attendance.reason = reason;

    updateAttendanceRecord(
      courseStudents[attendanceIndexState].attendance.id,
      attendanceRecord
    );
    closeEditReason()

    toast.success('Reason updated successfully')

  }
  const closeEditReason = () => {
    setisReason({
      show: false,
      status: ""
    })
    setReason('')
  }

  const isReasonAlreadyAdded = () => {
    const status = ['absent', 'leave']
    return status.includes(courseStudents[attendanceIndexState]?.attendance?.status)
  }

  const saveAttendanceRecord = async (status, courseStudent) => {

    if (!courseStudent?.email) {
      toast.error('Invalid student data');
      return;
    }

    if (!['present', 'absent', 'leave'].includes(status)) {
      toast.error('Invalid attendance status');
      return;
    }

    if (hasWriteAccess) {
      const attendanceIndex = courseStudents.findIndex(
        (att) => att.email === courseStudent.email
      );
      setAttendanceIndexState(attendanceIndex);
      setCourseStudentState(courseStudent);
      if ((status === 'absent' || status === 'leave') && !isReason.show && courseStudents[attendanceIndex].attendance?.status !== status) {
        setisReason({
          show: true,
          status
        })
        return
      }
      setAttendanceLoading({
        loading: true,
        email: courseStudent.email
      })
      const now = new Date();
      const createdAt = {
        seconds: Math.floor(now.getTime() / 1000),
        nanoseconds: (now.getTime() % 1000) * 1000000,
      };
      const attendanceRecord = {
        userId: courseStudent.email,
        attendanceDate: attendanceSearch,
        status,
        createdAt: createdAt,
        reason: reason.trim(),
        createdBy: user?.email,
      };
      try {
        if (courseStudents[attendanceIndex].attendance?.status === status) {
          await deleteSingleDoc('attendance', courseStudents[attendanceIndex].attendance.id)
          setAttendanceLoading({
            loading: false,
            email: ""
          })
          delete courseStudents[attendanceIndex].attendance;
          setCourseStudents(courseStudents);
          setRandomState(!randomState);
          toast.success(`Attendance removed for ${courseStudent.email}`);
        } else {
          if (attendanceIndex >= 0) {
            if (courseStudents[attendanceIndex].attendance) {
              updateAttendanceRecord(
                courseStudents[attendanceIndex].attendance.id,
                attendanceRecord
              );
              setAttendanceLoading({
                loading: false,
                email: ""
              })
              courseStudents[attendanceIndex].attendance.status = status;
              courseStudents[attendanceIndex].attendance.reason = reason;
              toast.success(`Attendance updated for ${courseStudent.email}`);
            } else {
              const addedDate = await setAttendanceRecord(attendanceRecord);
              attendanceRecord.id = addedDate;
              courseStudents[attendanceIndex].attendance = attendanceRecord;
              toast.success(`Attendance added for ${courseStudent.email}`);
              setAttendanceLoading({
                loading: false,
                email: ""
              })
            }
          }
        }
      } catch (error) {
        setAttendanceLoading({
          loading: false,
          email: ""
        });
        toast.error(`Failed to save attendance: ${error.message}`);
      }
      setTotal();
      setisReason({
        show: false,
        status: ""
      })

      setReason("")
      setCourseStudents(courseStudents);
    } else {
      toast.error(
        "You don't have access, please ask Super Admin to provide you access!"
      );
    }
  };

  const SaveAttendance = async (studentId, email) => {
    try {
      if (!studentId) throw new Error('Student ID not found');
      setLoading(true)
      const status = "present";
      const now = new Date();
      const createdAt = {
        seconds: Math.floor(now.getTime() / 1000),
        nanoseconds: (now.getTime() % 1000) * 1000000,
      };
      const attendanceRecord = {
        userId: email,
        attendanceDate: attendanceSearch,
        status,
        createdAt: createdAt,
        createdBy: user?.email,
      };
      const attendanceIndex = courseStudents.findIndex(
        (att) => att.studentId == studentId
      );
      if (attendanceIndex >= 0) {
        const isEmailExists = courseStudents.find((student) => student.email == email);
        if (!isEmailExists) {
          toast.error(`Student email not found`);
          setTimeout(() => {
            toast.error(`Please wait before another request`);
          }, 300)
          return;
        }
        if (courseStudents[attendanceIndex]?.attendance) {
          await updateAttendanceRecord(
            courseStudents[attendanceIndex].attendance.id,
            attendanceRecord
          );
          courseStudents[attendanceIndex].attendance.status = status;
          toast.success(`Attendance updated for ${email}`);
        } else {
          const docId = await setAttendanceRecord(attendanceRecord);
          attendanceRecord.id = docId;
          courseStudents[attendanceIndex].attendance = attendanceRecord;
          toast.success(`Attendance Added for ${email}`);
        }
        setTotal();
        setCourseStudents(courseStudents);
      } else {
        throw new Error('Student ID Not Found')
      }
    } catch (error) {
      errorSound.play();
      toast.error(`Error: ${error.message}`);
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  }

  const composeAllEmail = () => {
    const emails = courseStudents.map((student) => student.email);
    const AllEmails = emails.join(",");
    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${AllEmails}`;
    window.open(url, "_blank");
  };

  const handleSearchByDate = (e) => {
    setAttendanceSearch(e);
    setLoading(true)
    getStudents(e);
  };

  const composeSingleEmail = (courseStudent) => {
    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${courseStudent?.email}`;
    window.open(url, "_blank");
  };

  const getStudents = async (e) => {
    setLoading(true);
    setAttendanceSheet(false)
    setFilterBy('')
    setCourseStudents([]);
    const attendanceDocs = await getAttendance(e);
    let records = [];
    const bannedStudents = [];
    const notPaidSecondFee = [];
    const isSecondModuleStart = isDateOverForSecondModule(activeCourse?.startDate, activeCourse?.endDate)
    students?.forEach((student) => {
      const selectedCourseStudents = student?.courses?.find((course) => course.courseId === activeCourse?.id);

      if (!selectedCourseStudents) {
        return;
      }
      const isRefundedFee = selectedCourseStudents?.feeScreenshots?.find((courseFee) => courseFee.status === 'refunded')
      if (isRefundedFee) return

      if (student.banned) {
        bannedStudents.push(student);
        return;
      }

      const feeScreenshots = selectedCourseStudents.feeScreenshots || [];
      const feeVerified = feeScreenshots[0]?.status === "verified" || feeScreenshots[1]?.status === "verified";
      const feePaid = feeScreenshots[1]?.status;

      if (isSecondModuleStart && !feePaid && feeVerified) {
        const studentData = { ...student, docId: student.id, notPaidSecondFee: true };
        notPaidSecondFee.push(studentData);
      } else if (feeVerified) {
        const studentData = { ...student, docId: student.id };
        records.push(studentData);
      }
    });

    records = records.concat(notPaidSecondFee, bannedStudents)
    const sortedData = records.map((record) => {
      const attendance = attendanceDocs.find(
        (att) => att.userId === record.email
      );
      return attendance ? { ...record, attendance } : record;
    });
    setCourseStudents(sortedData);
    setBanned(bannedStudents.length)
    setLoading(false);
  };

  const columnData = getAttColumn(
    createAttendance,
    saveAttendanceRecord,
    attendanceLoading,
    showReasonNotation,
    showUpdateReasonModal,
    composeSingleEmail,
    setShowCalenderModal,
  )

  useEffect(() => {
    setTotal()
  }, [module, courseStudents])

  useEffect(() => {
    fetchStudents(activeCourse)
  }, [activeCourse])

  useEffect(() => {
    getStudents(attendanceSearch)
  }, [students])

  return (
    <>
      <AttendanceHeader
        module={module}
        setModule={setModule}
        attStatus={attendanceStatus}
        courseStudents={filteredStudent}
        search={search}
        setSearch={setSearch}
        createAttendance={createAttendance}
        setCreateAttendance={setCreateAttendance}
        activeCourse={activeCourse}
        composeAllEmail={composeAllEmail}
        filterBy={filterBy}
        setAttendanceSheet={setAttendanceSheet}
        setFilterBy={setFilterBy}
        SaveAttendance={SaveAttendance}
        attendanceSearch={attendanceSearch}
        handleSearchByDate={handleSearchByDate}
        loading={loading}
        attendanceSheet={attendanceSheet}
      />
      <div className='ant-design-table'>
        {attendanceSheet ? (
          <AttendanceSheet
            courseStudents={filteredStudent}
            filterBy={filterBy}
            searchText={search}
            selectedCourse={activeCourse}
            loading={loading}
          ></AttendanceSheet>
        ) : (
          <Table
            loading={loading}
            rowClassName={(record) => record.banned ? 'banned-student' : ''}
            columns={columnData}
            dataSource={filteredStudent}
            bordered={true}
            pagination={false}
            scroll={{ x: "auto" }}
          />
        )}
      </div>
      <Modal
        title={`Please ${isReasonAlreadyAdded() ? 'Edit' : 'Add'} reason for ${isReason.status}`}
        open={isReason.show}
        onOk={() => { isReasonAlreadyAdded() ? updateAttendanceReason() : saveAttendanceRecord(isReason.status, courseStudentState) }}
        confirmLoading={attendanceLoading.loading}
        onCancel={() => {
          reason ?
            closeEditReason() :
            saveAttendanceRecord(isReason.status, courseStudentState)
        }}
      >
        <Form layout="vertical">
          <Form.Item label="Reason" className="mb-0">
            <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Enter reason" />
          </Form.Item>
        </Form>
      </Modal>
      {showCalenderModal && (
        <CalenderModal
          showCalenderModal={showCalenderModal}
          email={showCalenderModal}
          closeModal={() => setShowCalenderModal(null)}
          selectedCourse={activeCourse}
        />
      )}
    </>
  )
}

export default AttendanceTable